import $ from 'jquery';
import formatEvents from './formatEvents';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatEvents(`[data-section-id="${e.detail.sectionId}"]`);
  });
};